import { api } from "./api";

export const batchList = async (addUrl = "") => {
  return await api.get(`/batch/list?${addUrl}`);
};

export const batchDetails = async (id) => {
  return await api.get(`/batch/details?id=${id}`);
};

export const batchDelete = async (id) => {
  return await api.post(`/batch/delete`, { id });
};

export const batchAdd = async (data) => {
  return await api.post(`/batch/add`, data);
};

export const batchStatusUpdate = async (data) => {
  return await api.post(`/batch/status/update`, data);
};

export const batchUpdate = async (data) => {
  return await api.post(`/batch/update`, data);
};
export const batchPromote = async (data) => {
  return await api.post(`/batch/promote`, data);
};

export const batchDetailsWithStudents = async (addUrl) => {
  return await api.get(`/batch/details/with/students?${addUrl}`);
};

export const batchStudentsMarksheetData = async (addUrl) => {
  return await api.get(`/marksheet/batch/student/data?${addUrl}`);
};

export const batchStudentsUpdateRollNumbers = (data) => {
  return api.post("/batch/roll/number/update", data);
};

export const saveStudentSubjectMapping = (data) => {
  return api.post("/student/subject/mapping/update", data);
};
